import * as React from 'react';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAButton } from '../../button/Button';
import { ContentOrganizerAdminStore } from '../stores/ContentOrganizerAdminStore';
import { inject, observer } from 'mobx-react';
import { IAPanel } from '../../panels';
import { IASiteListRadioDropDown } from '../../siteListRadioDropDown/SiteListRadioDropDown';
import ContentOrganizerService from '../../../services/ContentOrganizerService';

export interface IContentOrganizerSiteUrlSyncPanelProps {
  open: boolean;
  onClose: () => void;
  contentOrganizerAdminStore?: ContentOrganizerAdminStore;
}

export interface IContentOrganizerSiteUrlSyncPanelState {
  selectedSiteCollection?: string;
  syncStarted: boolean;
}

@inject('contentOrganizerAdminStore')
@observer
export class ContentOrganizerSiteUrlSyncPanel extends React.Component<IContentOrganizerSiteUrlSyncPanelProps, IContentOrganizerSiteUrlSyncPanelState> {

  constructor(props: IContentOrganizerSiteUrlSyncPanelProps) {
    super(props);
    this.state = {
      selectedSiteCollection: null,
      syncStarted: false,
    };
    this.props.contentOrganizerAdminStore.isMobile = window.innerWidth < 667;
  }

  public componentDidMount() {
  }

  public componentWillUnmount() {
    this.setState({ selectedSiteCollection: null });
  }

  public render(): JSX.Element {
    return (
      <IAPanel
        showNavigationBar={true}
        title={"Syncronize with site collection"}
        open={this.props.open}
        transition="slide"
        isMobile={this.props.contentOrganizerAdminStore.isMobile}
        width={400}
        close={this.props.onClose}
      >
        <div style={{padding: "0 40px"}}>
          <p>{new LocalizationService().strings.ContentOrganizerAdminInstance_SiteUrlSyncSiteSelectorFieldDescription}</p>
          <IASiteListRadioDropDown
            tenant={this.props.contentOrganizerAdminStore.tenant}
            environment={this.props.contentOrganizerAdminStore.environment}
            token={this.props.contentOrganizerAdminStore.token}
            label={new LocalizationService().strings.ContentOrganizer_SelectSiteCollection}
            placeholder={new LocalizationService().strings.ContentOrganizer_SiteSelectionPlaceHolder}
            singleOption={true}
            styles={{
              marginTop: "10px"
            }}
            themeColor={"rgb(35, 135, 155)"}
            onSelectOptions={(options) => {
              let selectedItem;
              options.forEach(option => {
                if (option.selected) {
                  selectedItem = option;
                }
              });
              if (selectedItem) {
                this.setState({ selectedSiteCollection: selectedItem.key });
              }
            }}
          />
          <IAButton
            label='Sync'
            buttonColor="#1c899d"
            icon='Refresh'
            disbaled={this.state.selectedSiteCollection === null || this.state.syncStarted}
            onClick={() => {
              this.setState({ syncStarted: true });
              ContentOrganizerService.syncContentOrganizerSiteUrl(
                this.props.contentOrganizerAdminStore.environment,
                this.props.contentOrganizerAdminStore.token,
                this.props.contentOrganizerAdminStore.tenant,
                this.props.contentOrganizerAdminStore.selectedInstance.settings.siteCollection,
                this.state.selectedSiteCollection
              ).then(() => {
                window.location.href = window.location.href.replace(
                  `instance=${this.props.contentOrganizerAdminStore.selectedInstance.settings.siteCollection}`,
                  `instance=${this.state.selectedSiteCollection}`
                ) + `&_invoked_by=site_url_sync&_reload=true`;
              });
            }}
          />
        </div>
      </IAPanel>
    );
  }
}